import { mapGetters } from 'vuex';
import { successMessage, errorMessage } from '@/utils/message.js';
import accountInfoService from '../account-info.service.js';
import ProcessNavigation from '@/components/process-navigation/index.vue';
import VoiceMessage from '@/components/voice-message/index.vue';
export default {
  components: {
    ProcessNavigation,
    VoiceMessage
  },
  data() {
    return {
      smsCodeShowCount: 60,
      smsCodeShowText: '获取验证码',
      processList: ['验证身份', '重置密码', '重置成功'],
      step: 1,
      form: {
        mobile: '',
        verifyCode: '',
        assignorCode: ''
      },
      rules: {
        verifyCode: [
          { required: true, message: '请输入图片验证码', trigger: 'blur' }
        ],
        assignorCode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur'}
        ]
      }
    };
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'captchaImageSrc',
      'ticket',
      'userType'
    ])
  },
  created() {
    this.updateCaptchaImage();
  },
  mounted() {
    this.form.mobile = this.userInfo && this.userInfo.mobile || '1';
  },
  methods: {
    // 更新图片验证码
    updateCaptchaImage() {
      this.$store.dispatch('getCodeImage').then(() => {
      }, error => {
        if (error && error.reason) {
          errorMessage(error.reason);
        } else {
          errorMessage('更新验证码失败，请重试');
        }
      });
    },
    // 手机验证码倒计时
    countDownOfSmsCode() {
      let _this = this;
      if (this.smsCodeShowCount >= 1) {
        _this.timer = setInterval(function() {
          _this.smsCodeShowCount--;
          _this.smsCodeShowText = _this.smsCodeShowCount + 'S';
          if (_this.smsCodeShowCount <= 0) {
            _this.smsCodeShowText = '重新获取';
            _this.smsCodeShowCount = 60;
            clearInterval(_this.timer);
          }
        }, 1000);
      }
    },
    // 获取手机验证码
    getSmsCode() {
      const mobile = this.form.mobile;
      // if (!mobile) {
      //   errorMessage('请先输入被授权人手机号码');
      //   return;
      // }
      // if (!RegExp.phone.test(mobile)) {
      //   errorMessage('请输入正确的手机号');
      //   return;
      // }
      if (!this.form.verifyCode) {
        errorMessage('请先输入图片验证码');
        return;
      }
      if (this.form.verifyCode && this.form.verifyCode.length !== 4) {
        errorMessage('请输入正确的图片验证码');
        return;
      }
      const form = {mobile: mobile, ticket: this.ticket, verifyCode: this.form.verifyCode};
      if (this.smsCodeShowCount === 60) {
        this.smsCodeShowText = '发送中...';
        this.$store.dispatch('getSmsCode', form).then(res => {
          if (res.code === '0') {
            this.countDownOfSmsCode();
            successMessage('验证码发送成功');
          }
        }, error => {
          this.updateCaptchaImage();
          this.smsCodeShowText = '重新获取';
          this.smsCodeShowCount = 60;
          if (error && error.reason) {
            errorMessage(error.reason);
          } else {
            errorMessage('获取验证码失败，请重试');
          }
        });
      }
    },
    validateForm() {
      let validStatus = false;
      this.$refs['form'].validate(valid => {
        if (valid) {
          validStatus = valid;
        }
      });
      return validStatus;
    },
    // 下一步
    nextStep() {
      if (!this.validateForm()) { return; };
      let params = {
        mobile: this.form.mobile,
        verifyCode: this.form.assignorCode
      };
      accountInfoService.authenticate(params).then(res => {
        if (res && res.code === '0') {
          console.log('下一步');
          this.$router.push('/person-center/account-info/reset-secondstep');
        } else {
          console.log('222');
          errorMessage(res.reason);
        }
      }, error => {
        console.log(error, 'dd');
        if (error && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    }
  }
  // resetPassword() {
  // let params = {
  //   mobile: form.mobile,
  //   userType: this.userInfo.type,
  //   originalPassWord: this.form.oldPassword,
  //   newPassWord: this.form.newPassword
  // };
  // accountInfoService.updatePassWord(params).then(res => {
  //   if(res && res.code === '0') {
  //     console.log(res.data);
  //   }
  // });
  // }
};
